import { BikeleasingContractListItemDTO } from 'probonio-shared-ui/api';

const SEARCHABLE_KEYS: Array<keyof BikeleasingContractListItemDTO> = ['firstName', 'lastName', 'email', 'contractNumber'];

function getSortValue(contract: BikeleasingContractListItemDTO, sortField: string): string | number | undefined {
  switch (sortField) {
    case 'employee.lastName':
    case 'lastName':
      return contract.lastName;
    case 'employee.firstName':
    case 'firstName':
      return contract.firstName;
    case 'employee.mail':
    case 'email':
      return contract.email;
    case 'contractNumber':
      return contract.contractNumber;
    case 'startDate':
      return contract.startDate ? new Date(contract.startDate).getTime() : undefined;
    case 'endDate':
      return contract.endDate ? new Date(contract.endDate).getTime() : undefined;
    case 'status':
      return contract.status;
    default:
      return undefined;
  }
}

function compareSortValues(a: string | number | undefined, b: string | number | undefined, direction: 'asc' | 'desc'): number {
  if (a == null && b == null) {
    return 0;
  }
  if (a == null) {
    return 1;
  }
  if (b == null) {
    return -1;
  }

  const base =
    typeof a === 'number' && typeof b === 'number'
      ? a - b
      : String(a).localeCompare(String(b), undefined, { sensitivity: 'base', numeric: true });

  return direction === 'asc' ? base : -base;
}

export function filterAndSortBikeleasingContracts(args: {
  contracts: BikeleasingContractListItemDTO[];
  statuses?: string[];
  searchText?: string;
  sortBy?: string[];
}): BikeleasingContractListItemDTO[] {
  const searchText = args.searchText?.trim().toLowerCase();

  const filtered = args.contracts.filter(contract => {
    if (!contract.status || (args.statuses && !args.statuses.includes(contract.status))) {
      return false;
    }
    if (!searchText) {
      return true;
    }

    return SEARCHABLE_KEYS.some(key =>
      String(contract[key] || '')
        .toLowerCase()
        .includes(searchText),
    );
  });

  if (!args.sortBy?.length) return filtered;

  return [...filtered].sort((a, b) => {
    for (const sortDef of args.sortBy!) {
      const [field, direction = 'asc'] = sortDef.split(':');
      const result = compareSortValues(getSortValue(a, field), getSortValue(b, field), direction === 'desc' ? 'desc' : 'asc');
      if (result !== 0) {
        return result;
      }
    }
    return 0;
  });
}
